import { managerService } from './manager.service';
import store from '../store';
export const templateService = {

  async applyTemplate(appId, templateId, audienceId) {
    try {
      const response = await managerService.post('/template/apply', {
        template_id: templateId,
        audience_id: audienceId
      }, { aid: appId });
      store.dispatch('configFetch', 'template');
      store.dispatch('configFetch', 'parameter');
      return response.data.result;
    } catch (error) {
      console.error('Error applying template:', error);
      throw error;
    }
  },

  async undoTemplate(appId, templateId, audienceId) {
    try {
      const response = await managerService.post('/template/undo', {
        template_id: templateId,
        audience_id: audienceId
      }, { aid: appId });
      store.dispatch('configFetch', 'template');
      store.dispatch('configFetch', 'parameter');
      return response.data.result;
    } catch (error) {
      console.error('Error undoing template:', error);
      throw error;
    }
  },

  async getTemplateApplications(appId, audienceId, templateId) {
    try {
      const response = await managerService.get('/template/applications', { 
        aid: appId,
        audience_id: audienceId,
        template_id: templateId 
      });
      return response.data.result.data;
    } catch (error) {
      console.error('Error fetching template applications:', error);
      throw error;
    }
  }
}; 